import { useQuery } from "react-query";
import { CommApiInstance } from "Utils/CommApiInstance";
import MgpStore from "Stores/Store";
import LangLstDataType from "Interface/Apis/LangLst.Interface";
import { useState } from "react";
import { useSelector } from "react-redux";


export const LangTxtInqApi = async (fepSvcKindOverride?: string) => {
    const fepSvcKind = fepSvcKindOverride || MgpStore.getState().PageSetState.PageState;
    return await CommApiInstance.post(`comm/lang/page`,{
        apiBody: {
            fepSvcKind: fepSvcKind
        }
    })
    .then((Resp) => Resp.data.apiBody);
}
const UseLangLstQuery = (fepSvcKindOverride?: string) => {
    // useSelector로 실시간 상태 구독
    const currentLang = useSelector((state: any) => state.LangSetState.Lang);
    const currentPageState = useSelector((state: any) => state.PageSetState.PageState);
    const queryFepSvcKind = fepSvcKindOverride || currentPageState;

    return useQuery<LangLstDataType[]>({
        queryKey: ["LangTxtRendering", currentLang, queryFepSvcKind],
        queryFn: () => LangTxtInqApi(fepSvcKindOverride),
        refetchOnReconnect:false,
        staleTime: 5 * 60 * 1000, // 5분
        cacheTime: 10 * 60 * 1000, // 10분
    })
}

export default UseLangLstQuery;